import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { SystemFieldsService } from '@app/services/system-fields/system-fields.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { LoaderService } from '@shared/components/loader/loader.service';

@Component({
  selector: 'app-edit-form-field',
  templateUrl: './edit-form-fields.html',
  styleUrls: ['./edit-form-fields.scss']
})
export class EditFormFieldComponent implements OnInit {

  public field;
  public editor;
  public form: FormControl;
  @Input() formBuildInfo;
  @Input() currentForm;
  @Output() valueChanged = new EventEmitter<any>();


  constructor(
    private serviceNotification: NotificationService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.defineFieldOptions(this.formBuildInfo);
  }

  public defineFieldOptions(field) {
    this.field = field;
    this.form = new FormControl('', field.validate !== null ? this.getValidators(field.validate) : null);
    if (field.keyGroup) {
      this.form.setValue(this.currentForm.components[0][field.keyGroup][field.key]);
    } else {
      this.form.setValue(this.currentForm.components[0][field.key] ?? this.formBuildInfo.value);
    }
    this.onChanges();
  }

  onChanges(): void {
    this.form.valueChanges.subscribe(val => {
      this.valueChanged.emit({
        key: this.field.key, value: this.form.value, keyGroup : this.field.keyGroup !== null ? this.field.keyGroup : false
      });
    });
  }

  public getValidators(fieldRules) {
    const validators = [];
    for (const key in fieldRules) {
      if (fieldRules.hasOwnProperty(key)) {
        const value = fieldRules[key];
        switch (key) {
          case 'required':
            if (value) {
              validators.push(Validators.required);
            }
            break;
            case 'maxLength':
              validators.push(Validators.maxLength(value));
              break;
            case 'minLength':
              validators.push(Validators.minLength(value));
              break;
            case 'max':
              validators.push(Validators.max(value));
              break;
            case 'min':
              validators.push(Validators.min(value));
              break;
            case 'pattern':
              validators.push(Validators.pattern(value));
              break;
            case 'email':
            validators.push(Validators.email);
            break;
          default:
            break;
        }
      }
    }
    return validators;
  }


}
